// eslint-disable-next-line no-unused-vars
function loginInit () {
  $(document).ready(function () {
    const $langForm = $('#language-form')
    const $langCode = $('#language-code')
    $langCode.find('#' + i18next.language).attr('selected', true)
    if ($langForm.length) {
      $langCode.change(function () {
        const cookie = 'i18next=' + $langCode.val() + ';secure=true; path=/'
        document.cookie = cookie
        window.location.reload(true)
      })
    }
  })
}
